<template>
  <div id="inline-link">
    <div class="text" v-html="text" @click="inlineLinkClicked"></div>
  </div>
</template>

<script>
export default {
  name: "InlineLink",
  props: {
    text: {
      required: true
    }
  },
  methods: {
    inlineLinkClicked() {
      this.$emit("inlineLinkClicked");
    }
  }
};
</script>
<style lang="scss" scoped>
#inline-link {
  .text {
    cursor: pointer;
    &:hover {
      text-shadow: 0px 3px 4px rgba(0, 0, 0, 0.4);
    }
  }
}
</style>
